import { FEATURE_VARIANTS } from "../../data/siteContent";
import type { FeatureVariant } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";
import { FeatureMockup } from "./FeatureMockup";

import styles from "./Features.module.css";

function FeatureRow({
  variant,
  reverse,
}: {
  variant: FeatureVariant;
  reverse: boolean;
}) {
  const { copy } = useLocale();
  const block = copy.features.blocks[variant];

  return (
    <article className={`${styles.row} ${reverse ? styles.reverse : ""}`}>
      <div className={styles.text}>
        <h3 className={styles.blockTitle}>{block.title}</h3>
        <p className={styles.blockDesc}>{block.description}</p>
        <p className={styles.tags}>{block.tags}</p>
      </div>
      <FeatureMockup variant={variant} />
    </article>
  );
}

export function Features() {
  const { copy } = useLocale();

  return (
    <Section title={copy.features.title}>
      <div className={styles.list}>
        {FEATURE_VARIANTS.map((variant, index) => (
          <FeatureRow
            key={variant}
            variant={variant}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </Section>
  );
}
